export const RowAnimationVariants = {
	hideRow: { opacity: 0, height: 0 },
	initialRow: { opacity: 0 },
	showRow: { opacity: 1 },
};

export const RowTransitions = { opacity: { duration: 0.2 }, height: {duration: 0.3} }